export default __webpack_public_path__ + "static/media/Banner_CONOCELES-EDITABLE-02.4d6a35d5.png";